import { Link } from "react-router";
import { cn } from "@/utils/css";

export const SearchTab = ({ text, onClick, isActive, to }) => {
    const className = cn("px-4 py-2 text-cm-p-text-primary text-base bg-transparent h-11 border-b-2 border-b-transparent", {
        "border-b-cm-p-accent font-medium": isActive,
    });
    return to ? (
        <Link className={className} to={to} onClick={onClick}>
            {text}
        </Link>
    ) : (
        <button className={className} onClick={onClick} type="button">
            {text}
        </button>
    );
};
